import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posPaymentReportWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.payment-report",
  name: "POS payment methods",
  description: "POS payment methods using the reusable report-widget visualization.",
  apps: [
    "point-of-sale",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.payments",
      ...period(30),
      select: [
        {
          type: "field",
          field: "payment_method",
          as: "payment_method",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "amount",
          as: "amount",
        },
      ],
      group_by: [
        {
          field: "payment_method",
        },
      ],
      order_by: [
        {
          ref: "amount",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "POS payment methods",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$32,840",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
